/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebdayfri3Inputs */

const en_placewebdayfri3 = /** @type {(inputs: Placewebdayfri3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fri`)
};

const de_placewebdayfri3 = /** @type {(inputs: Placewebdayfri3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fr`)
};

/**
* | output |
* | --- |
* | "Fri" |
*
* @param {Placewebdayfri3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebdayfri3 = /** @type {((inputs?: Placewebdayfri3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebdayfri3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebdayfri3(inputs)
	return de_placewebdayfri3(inputs)
});
export { placewebdayfri3 as "placeWebDayFri" }